mainApp.component('cloudAccessApps', {
	templateUrl: '/public/components/cloudAccess/cloud-access-apps.component.html',
	bindings: {
	},
	controller: cloudAccessAppsController
});

function cloudAccessAppsController($scope, $state, $controller, $timeout, GeneralUtilsService, CloudAccessService, CopyToClipboardService) {

    $controller('ConfigController', {$scope: $scope, $timeout: $timeout});

    var ctrl = this;

    ctrl.$onInit = function() {
        reset();
        ctrl.originalApp = {
            tls: null
        };
        ctrl.getAccountCloudAccessConfiguration();
    };

    // required to show unsaved changes warning when switching to a different screen
    $scope.$root.hasChanges = function() {
        return ctrl.hasChanges();
    }

    //used to enable save button
    ctrl.hasChanges = function () {
        return !angular.equals(ctrl.originalApp, ctrl.application) || ctrl.iconChanged;
    }

    ctrl.updateIconChanged = function(imageText, imageType){
        ctrl.iconChanged = true;
        ctrl.application.imageText = imageText;
        ctrl.application.imageType = imageType;
    }
     //reset changes made by user
    function reset() {
        ctrl.appsdatamodified = new Date().getTime();
        ctrl.newApplication = {name: 'cloudApplication', id: GeneralUtilsService.getRandomId()};
        ctrl.originalApp = angular.copy(ctrl.application);
        ctrl.iconChanged = false;
    }

    ctrl.stopLoad = function() {
        $scope.$broadcast('stop-load');
    }

    ctrl.getAccountCloudAccessConfiguration = function() {
        CloudAccessService.getCloudAccessSettings($state.params.accountId, ctrl.updateView);
    }

    ctrl.updateView = function(data) {
        ctrl.cloudAccessConfiguration = data.cloudAccessConfiguration;
        if (data.cloudAccessConfiguration.fqdn) {
            ctrl.fqdn = data.cloudAccessConfiguration.fqdn;
        }
        ctrl.originalConfiguration = angular.copy(ctrl.cloudAccessConfiguration);
        if (ctrl.cloudAccessConfiguration.applications.length === 0) {
            return;
        }
        if (!ctrl.selectedAppId) {
            ctrl.selectedAppId = ctrl.cloudAccessConfiguration.applications[0].id;
        }
        $timeout(() => ctrl.updateDisplayedApp(), 1, true);
    }

    ctrl.updateDisplayedApp = function() {
        if (!ctrl.cloudAccessConfiguration) {
            return;
        }
        //flush changes of previous app
        if(ctrl.hasChanges()) {
            ctrl.flushChanges($scope.tableConfig.selectedId);
        }
        $scope.tableConfig.selectedId = ctrl.selectedAppId;
        ctrl.application = ctrl.cloudAccessConfiguration.applications[ctrl.findCurrentAppIndex()]
        ctrl.originalApp = angular.copy(ctrl.application);
    }

    ctrl.flushChanges = function(id) {
        ctrl.application = angular.copy(ctrl.originalApp);
        ctrl.cloudAccessConfiguration.applications[ctrl.findAppIndexById(id)]= ctrl.application;
        ctrl.iconChanged = false;
    }

    ctrl.saveChanges = function() {
        ctrl.cloudAccessConfiguration.applications[ctrl.findCurrentAppIndex()] = ctrl.application;
        CloudAccessService.saveAccountWithCloudConfiguration($state.params.accountId,ctrl.cloudAccessConfiguration, ctrl.successCallback, ctrl.failureCallback);
    }

    ctrl.findCurrentAppIndex = function() {
        return ctrl.cloudAccessConfiguration.applications.findIndex(app => app.id === ctrl.selectedAppId)
    }

    ctrl.findAppIndexById = function(id) {
        return ctrl.cloudAccessConfiguration.applications.findIndex(app => app.id === id)
    }

    ctrl.successCallback = function(data) {
        ctrl.stopLoad();
        $scope.$root.handleServerResponse(data, "", "Application saved successfully");
        $scope.$broadcast('modelSavedEvent');
        reset();
        ctrl.updateView(data.model);
    }

    ctrl.failureCallback = function(data) {
        ctrl.stopLoad();
        $scope.$root.handleServerResponse(data, '', '');
    }

    $scope.tableConfig = {
        hasChanges: ctrl.hasChanges,
        noAutoCheckboxSelect: true,
        mode: 'list',
        pageSize: 50,
        dataURL: function () {
            return '/getCloudApplications?accountId=' + ($state.params.accountId ? $state.params.accountId : '');
        },
        processData: function (items) {
            items.forEach(function(item) {
                if (item.appName) {
                    item.caption = item.appName;
                }
               return items;
            });
        },
        titleSearch: 'Applications',
        accountId: $state.params.accountId,
        sortButton: true,
        fields: [{label: 'Name', path: 'appName', template: '<span>{{item.appName}}</span>' },
        ],
        type: 'CloudApplication',
        addAction: function () {$scope.$root.openPopup('add-application-dialog');},
        onSelect: function (index) {
            if ($scope.tableConfig.selectedItems[0]) {
                ctrl.selectedAppId = $scope.tableConfig.selectedItems[0].id;
            }
            $scope.$root.clearErrors();
            ctrl.updateDisplayedApp();
        },
        actions: ["remove"],
        nameField: "appName",
        searchField: "appName",
        keepPageOnRefresh: true,
        height: $scope.getContentHeight()
    };

    ctrl.addApplication = function() {
        //create new configuration with new added application
        let newConfiguration = angular.copy(ctrl.cloudAccessConfiguration);
        ctrl.newApplication.keepSourceIp = true;
        ctrl.newApplication.tls = true;
        newConfiguration.applications.push(ctrl.newApplication);

        //save the account with the new cloud configuration
        CloudAccessService.saveAccountWithCloudConfiguration($state.params.accountId,newConfiguration, onAddApplicationSuccess, onAddApplicationError);
    };

    var onAddApplicationSuccess = function(data){
        $scope.$root.closePopup('add-application-dialog');
        $scope.$root.handleServerResponse(data, '', 'Changes saved successfully');
        $scope.$broadcast('stop-load');
        reset();
        ctrl.selectedAppId = data.model.cloudAccessConfiguration.applications[data.model.cloudAccessConfiguration.applications.length - 1].id
        ctrl.updateView(data.model);
    }

    var onAddApplicationError = function(data){
        $scope.$root.handleServerResponse(data, '', '');
        $scope.$broadcast('stop-load');
    }

    ctrl.onSuccessfulItemRemove = function(entitiesToDelete, data) {
        postDelete();
    }

    function postDelete() {
        ctrl.application = false;
        reset();
        delete ctrl.selectedAppId;
        ctrl.getAccountCloudAccessConfiguration();
    }

    ctrl.copyToClipboard = function (application) {
        CopyToClipboardService.copy(ctrl.urlPreview(application));
    }


    ctrl.urlPreview = function (application) {
        if(!application)
            return '';
        if (!ctrl.cloudAccessConfiguration || !ctrl.cloudAccessConfiguration.settings)
            return '';
        let fqdn = ctrl.fqdn || '-missing_portal_URL'
        let hostPrefix = application.hostPrefix ? (application.hostPrefix + '-') : '';
        let basePath = application.basePath ? ('\/'+application.basePath) : '';
        let hostSuffix = application.hostSuffix ? ('\/'+application.hostSuffix) : '';
        return 'https://' + hostPrefix + fqdn + '.via.catonetworks.com' + hostSuffix + basePath;
    }
}
